<template>
<BodyBody />
</template>

<script>
import BodyBody from '/src/components/BodyBody.vue';
export default {
    name: 'BodyComponent',
    components: {
        BodyBody
    }

}
</script>

<style>
.big {
    font-size: 200%;
}

body {
    background-color: aliceblue;
}
</style>
